/* eslint-disable @trello/disallow-filenames */
import { MoonshotSteps } from './campaigns';
import { Noun } from '@trello/analytics';
import { MoonshotOrganizationQuery } from './MoonshotOrganizationQuery.generated';
import { MoonshotQuery } from './MoonshotQuery.generated';
import React from 'react';

export enum ExperimentVariations {
  CONTROL = 'control',
  NOT_ENROLLED = 'not-enrolled',
  EXPERIMENT = 'experiment',
}
export interface MoonshotSubmitFunction {
  (step?: MoonshotSteps, options?: { redirect?: boolean }): void;
}

export interface MoonshotStep {
  step: number;
  key: MoonshotSteps;
  render: (options: {
    onSubmit: MoonshotSubmitFunction;
    orgId?: string;
  }) => React.ReactNode | null;
  noun: Noun;
}

export interface MoonshotAnalyticsAttributes {
  idEnterprise: string | null;
  isEnterprise: boolean;
  orgId: string;
  confirmed: boolean | undefined;
  moonshotVariation: string;
}
export interface MoonshotContextState {
  currentStep: MoonshotSteps;
  onSubmit: MoonshotSubmitFunction;
  orgId: string;
  organization?: MoonshotOrganizationQuery['organization'];
  loading: boolean;
  idEnterprise: string | null;
  isEnterprise: boolean;
  moonshotCampaign?: NonNullable<MoonshotQuery['member']>['campaigns'][0];
  isFreeTrial: boolean;
  member?: MoonshotQuery['member'];
  setOrgId(id: string): void;
  analyticsAttributes: MoonshotAnalyticsAttributes | undefined;
}
